import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ForceSSLService {

  constructor() {
    if(typeof environment.forceRedirectToHTTPS === 'boolean' && environment.forceRedirectToHTTPS === true) {
      if (document.location.protocol !== 'https:') {
        location.replace(`https:${location.href.substring(location.protocol.length)}`);
      }
    }
  }
}
